import useAuth from "./hooks/useAuth";
import { useEffect, useState } from "react";
import Selector from "./Components/Selector";
import UserSettings from "./UserSettings";
import UserStats from "./UserStats";

const UserProfile = ({successHandler}) => {
    const {auth, setAuth} = useAuth();
    const [section, setSection] = useState();
    const tabs = ['User stats and results', 'User settings'];
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    useEffect(() => {
        setSection(tabs[activeTabIndex]);
    }, [activeTabIndex]);

    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            {/* Header with back button */}
            <div className="sticky top-0 z-10 bg-white/95 backdrop-blur-sm border-b border-gray-200 px-4 py-4 shadow-sm">
                <div className="flex items-center justify-between max-w-7xl mx-auto w-full">
                    <button 
                        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors group"
                        onClick={() => { successHandler(false) }}      
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:-translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        <span className="font-medium hidden sm:inline">Back to Main View</span>
                        <span className="font-medium sm:hidden">Back</span>
                    </button>
                    
                    <h1 className="text-xl font-bold text-blue-700 text-center flex-1 mx-4">
                        User Profile
                    </h1>
                    
                    {/* Spacer for balance */}
                    <div className="w-20 sm:w-24"></div>
                </div>
            </div>

            {/* Main Content */}
            <div className="flex-1 w-full">
                {/* Tab Selector - Keep constrained */}
                <div className="p-4 sm:p-6 max-w-4xl mx-auto w-full">
                    <div className="mb-6 sm:mb-8">
                        <Selector 
                            clickHandler={(tab_index) => {
                                setActiveTabIndex(tab_index);
                            }} 
                            tabsData={tabs} 
                            active={activeTabIndex}
                        />
                    </div>
                </div>

                {/* Content Area - Full width for stats */}
                {section && (
                    <div className="w-full">
                        {section === 'User stats and results' && (
                            <div className="w-full">
                                <UserStats/>
                            </div>
                        )} 

                        {section === 'User settings' && (
                            <div className="max-w-4xl mx-auto w-full px-4 sm:px-6">
                                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                                    <div className="p-4 sm:p-6 md:p-8">
                                        <UserSettings/>  
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default UserProfile;